<template>
    <v-select
          dense
          :items="items"
          placeholder='Seleccione un Origen'
          label="Origen de la Cotización"
          :loading="loading"
          :prepend-inner-icon="icon"
          item-value="id"
          item-text="name"
          v-model="value"
          @input="updateValue"
          @change="change"
          outlined
          :error-messages="errors"
          return-object
          :disabled="disabled"
    >
      
    </v-select>
</template>

<script>

import notifications from '../../utils/notifications'

export default {
  name:'OriginSelection',
  //props:['value','errors','icon','loading','disabled'],
  props:{
    value:{
      type:Object,
      default:()=>({id:''})
    },
    errors:{
      type:Array,
      default:()=>[]
    },
    icon:{
      type:String,
      default:''
    },
    loading:{
      type:Boolean,
      default:false
    },
    disabled:{
      type:Boolean,
      default:false
    },
    filtro:{
      type:Boolean,
      default:false
    }
  },
  data:()=>({
    items:[]
  }),
  methods:{
    updateValue(){
      this.$emit('input',this.value.id)
    },
    change(){
      this.$emit('change',this.value.id)
    }
  },
  mounted(){
    if (this.filtro){
      this.items=[{name:'Todos',id:''},...this.$store.state.origins]
    }else this.items=this.$store.state.origins
  }

}
</script>